import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

export default function Badge({
  variant,
  children
}: {
  variant: 'success' | 'warning' | 'neutral' | 'info';
  children: ReactNode;
}) {
  const map = {
    success: 'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300',
    warning: 'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300',
    neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-500/20 dark:text-slate-200',
    info: 'bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300'
  };

  return <span className={cn('inline-flex rounded-full px-2.5 py-1 text-xs font-semibold', map[variant])}>{children}</span>;
}
